import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { TaskStatusEnum } from '@data-access/bulk-operations-api';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'di-grid-status-col-cell-renderer',
  templateUrl: './grid-status-col-cell-renderer.component.html',
  host: {
    class: 'tw:flex tw:justify-center tw:items-center',
    '[class.ga-tag]': 'isSuccessful || isFailed',
    '[class.ga-tag--success]': 'isSuccessful',
    '[class.ga-tag--error]': 'isFailed',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridStatusColCellRendererComponent implements ICellRendererAngularComp {
  private readonly cdr = inject(ChangeDetectorRef);
  isSuccessful: boolean;
  isFailed: boolean;
  isPending: boolean;

  agInit(params: ICellRendererParams<TaskStatusEnum>): void {
    this.setCellStatus(params.value);
    this.cdr.markForCheck();
  }

  refresh(params: ICellRendererParams<TaskStatusEnum>): boolean {
    this.setCellStatus(params.value);
    this.cdr.markForCheck();
    return true;
  }

  private setCellStatus(taskStatus: TaskStatusEnum): void {
    this.isSuccessful = taskStatus === TaskStatusEnum.Successful;
    this.isFailed = [TaskStatusEnum.Failed].includes(taskStatus);
    this.isPending = !this.isSuccessful && !this.isFailed;
  }
}
